/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const InboxSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M2 17v-5.384a3 3 0 0 1 .243-1.182L4.22 5.818A3 3 0 0 1 6.978 4h10.044a3 3 0 0 1 2.757 1.818l1.978 4.616c.16.373.243.776.243 1.182V17a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3Zm17.824-6-1.883-4.394a1 1 0 0 0-.92-.606H6.979a1 1 0 0 0-.919.606L4.176 11H9.5a.5.5 0 0 1 .5.5v.5c0 .729.263 1.202.602 1.503.357.317.861.497 1.398.497.537 0 1.041-.18 1.398-.497.339-.301.602-.774.602-1.503v-.5a.5.5 0 0 1 .5-.5h5.324Z" /></svg>);
const InboxSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={InboxSolidBase} {...rest} ref={ref} />);
export default InboxSolid;